import Vue from 'vue'

import {
    forEach as _forEach,
    orderBy as _orderBy,
} from 'lodash'

import CarMarkModel from '@/models/CarMarkModel'

// -----------------------------------------------------------------------------

const state = {
    carMarks: {},
    isLoading: false,
}

const getters = {
    getCarMarks: state => {
        return _orderBy(state.carMarks, ['id'], ['asc'])
    },

    getCarMark: state => carMarkId => {
        return state.carMarks[carMarkId] || null
    },
}

const mutations = {
    setCarMarks(state, payload) {
        state.carMarks = {}

        _forEach(payload, item => {
            const CarMark = new CarMarkModel(item)

            Vue.set(state.carMarks, CarMark.id, CarMark)
        })
    },

    setCarMark(state, payload) {
        const CarMark = new CarMarkModel(payload)

        Vue.set(state.carMarks, CarMark.id, CarMark)
    },

    setIsLoading(state, payload) {
        state.isLoading = !!payload
    },
}

const actions = {
    fetch({ commit }) {
        commit('setIsLoading', true)
        return new Promise((resolve, reject) => {
            const response = {
                items: [
                    {
                        id: 1,
                        name: 'BMW',
                    },
                    {
                        id: 2,
                        name: 'KIA',
                    },
                ],
            }

            commit('setCarMarks', response.items)
            commit('setIsLoading', false)

            resolve()
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
}
